import React from 'react';
import cx from 'classnames';
import { Row, Col } from 'react-bootstrap';
import { ChromePicker } from 'react-color'
import InputField from 'src/legacy/components/InputField';
import styles from './driftActivationView.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';

class DriftActivationView extends React.Component {
  constructor(props){
    super(props);
    const integration = this.props.integration;

    this.state = {
      id : integration && integration.configuration.id || '',
      backgroundColor : integration && integration.configuration.backgroundColor || '#E51058',
      foregroundColor : integration && integration.configuration.foregroundColor || '#ffffff',
      activeColor : integration && integration.configuration.activeColor || '#E51058',
      textColor : integration && integration.configuration.textColor || '#ffffff',
      welcomeMessage : integration && integration.configuration.welcomeMessage || 'Hello there!',
      errors: {},
      colorPicker : {
        background : false,
        foreground : false,
        active : false,
        text : false
      }
    }
    this._handleAuthenticationClick = this._handleAuthenticationClick.bind(this);
    this._handleSaveChangesClick = this._handleSaveChangesClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);
    this._handleColorPickerClick = this._handleColorPickerClick.bind(this);
    this._handleColorPickerClose = this._handleColorPickerClose.bind(this);
   
    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedDrift = localizedStrings.components.integrations.drift;
  }

  _handleColorPickerClick(field){
    this.setState({ 
      colorPicker : {
      [field] : !this.state[field] 
      }
    })
  }
  
  _handleColorPickerClose(field){
    this.setState({ 
      colorPicker : {
        [field] : false
      }
    })
  }

  _handleColorPickerChangeComplete(color, field) {
    this.setState({ 
      [field]: color.hex 
    });
  };

  _handleFieldChange(field, e){
    let value = e.target.value;
    this.setState({
      [field]: value
    });
  }

  _handleSelectChange(field, e){
    this.setState({
      alignment: field
    })
  }

  _handleAuthenticationClick(){
    let errors = this._validateForm();

    this.setState({
      errors: errors
    });

    if(Object.keys(errors).length > 0){      
      return;
    }
    this.props.activateAccount( this._prepareConfigurationDetails(), "driftchat" );
  }
  
  _handleSaveChangesClick(source){
    let errors = this._validateForm();

    this.setState({
      errors: errors
    });

    if(Object.keys(errors).length > 0){      
      return;
    }
    this.props.updateConfiguration( this._prepareConfigurationDetails(), "driftchat" )
    .then((response) => {
      if(response.type === "driftchat" && source === "activate"){
        this.props.trackAdoptionMetricsForPluginConnectedEvent('Drift');      
    }
    })
    .catch(error => {
      console.error("Error activating account:", error);
    });
  }

  _handleCancelClick(){
    this.setState({
      id : this.props.integration.configuration.id,
      backgroundColor : this.props.integration.configuration.backgroundColor,
      foregroundColor : this.props.integration.configuration.foregroundColor,
      activeColor : this.props.integration.configuration.activeColor,
      textColor : this.props.integration.configuration.textColor,
      welcomeMessage : this.props.integration.configuration.welcomeMessage
    });
  }

  _prepareConfigurationDetails(){
    let configuration = {
      id : this.state.id,
      backgroundColor : this.state.backgroundColor,
      foregroundColor : this.state.foregroundColor,
      activeColor : this.state.activeColor,
      textColor: this.state.textColor,
      welcomeMessage : this.state.welcomeMessage

    }
    return configuration;
  }

  _validateForm(){
    var errors = {};
    if(!this.state.id || this.state.id.trim() == ''){
      errors['load'] = this.localizedDrift.load_error
    }
    return errors;
  }

  rightAlignPos(){
    let left = ( 240 - (20 * 250 ) / 1366 );
    return left +'px'
  }

  leftAlignPos(){
    let left = (5 + (20 * 250 ) / 1366 );
    return left +'px'
  }

  calculateTopPosition(){
    let top = ( 186 - (20 * 250 ) / 1366 );
    return top +'px'
  }

 
  render(){

    const rightAligned = {
      left: this.rightAlignPos(),
      top: this.calculateTopPosition(),
      background: this.state.backgroundColor
    }

    const leftAligned = {
      left: this.leftAlignPos(),
      top: this.calculateTopPosition(),
      background: this.state.backgroundColor
    }

    const foregroundColor = {
      background : this.state.foregroundColor
    }

    var advancedSettings = "https://help.drift.com/getting-started/set-up-profile";
    if(this.state.id && this.state.id.length > 5){
      advancedSettings = `https://app.drift.com/settings/widget`;
    }

    return (
      <Row>
        <div className={styles.content}>
          <h1>{ this.localizedDrift.activate.title }</h1>
          <Row>
          <Col sm={8} className = { styles.column }>
            <p>{ this.localizedDrift.activate.sub_text }</p>
            <div className={styles.form}>
            <Col sm={12} className = { styles.column }>
              <InputField 
                className={styles.field} 
                title={ this.localizedDrift.activate.drift_id }
                value = { this.state.id }
                placeholder={ this.localizedDrift.activate.placeholder.drift_id }
                onChange={this._handleFieldChange.bind(this, 'id')}
                errorMessage={this.state.errors['load']}
              />
              </Col>
              <Row className = {cx(styles.row)}>
                <Col sm={6}  className={styles.colorPickerColumn}>
                  <InputField
                    title={`${ this.localizedDrift.activate.background}:`}
                    type="text"
                    value = { this.state.backgroundColor }
                    onChange={this._handleFieldChange.bind(this, 'backgroundColor')}
                    errorMessage={this.state.errors['backgroundColor']}
                  />
                  <div className = { styles.colorPicker }  onClick = { () => this._handleColorPickerClick('background') }>
                    <i className={"fa fa-eyedropper"} aria-hidden="true"></i>
                  </div>
                  
                  { this.state.colorPicker.background && 
                    <div className = { styles.popover } >
                      <div className = { styles.cover } onClick={ () => this._handleColorPickerClose('background') }/>
                      <ChromePicker 
                        color = { this.state.backgroundColor }
                        onChange={ (color) => this._handleColorPickerChangeComplete(color, 'backgroundColor') }
                      />
                    </div>  
                  }
                </Col>
                <Col sm={6} className={styles.colorPickerColumn}>
                  <InputField
                     title={`${ this.localizedDrift.activate.foreground}:`}
                    type="text"
                    value = { this.state.foregroundColor }
                    onChange={this._handleFieldChange.bind(this, 'foregroundColor')}
                    errorMessage={this.state.errors['foregroundColor']}
                  />
                  <div className = { styles.colorPicker }  onClick = { () => this._handleColorPickerClick('foreground') }>
                    <i className={"fa fa-eyedropper"} aria-hidden="true"></i>
                  </div>
                  
                  { this.state.colorPicker.foreground && 
                    <div className = { styles.popover } >
                      <div className = { styles.cover } onClick={ () => this._handleColorPickerClose('foreground') }/>
                      <ChromePicker 
                        color = { this.state.foregroundColor }
                        onChange={ (color) => this._handleColorPickerChangeComplete(color, "foregroundColor")  }
                      />
                    </div>  
                  }
                </Col>
              </Row>
              <Row className = {cx(styles.row)}>
                <Col sm={6} className={styles.colorPickerColumn}>
                  <InputField
                    title={`${ this.localizedDrift.activate.active}:`}
                    type="text"
                    value = { this.state.activeColor }
                    onChange={this._handleFieldChange.bind(this, 'activeColor')}
                    errorMessage={this.state.errors['activeColor']}
                  />
                  <div className = { styles.colorPicker }  onClick = { () => this._handleColorPickerClick('active') }>
                    <i className={"fa fa-eyedropper"} aria-hidden="true"></i>
                  </div>
                  
                  { this.state.colorPicker.active && 
                    <div className = { styles.popover } >
                      <div className = { styles.cover } onClick={ () => this._handleColorPickerClose('active') }/>
                      <ChromePicker 
                        color = { this.state.activeColor }
                        onChange={ (color) => this._handleColorPickerChangeComplete(color, 'activeColor') }
                      />
                    </div>  
                  }
                </Col>
                <Col sm={6} className={styles.colorPickerColumn}>
                  <InputField
                    title={`${ this.localizedDrift.activate.text}:`}
                    type="text"
                    value = { this.state.textColor }
                    onChange={this._handleFieldChange.bind(this, 'textColor')}
                    errorMessage={this.state.errors['textColor']}
                  />
                  <div className = { styles.colorPicker }  onClick = { () => this._handleColorPickerClick('text') }>
                    <i className={"fa fa-eyedropper"} aria-hidden="true"></i>
                  </div>
                  
                  { this.state.colorPicker.text && 
                    <div className = { styles.popover } >
                      <div className = { styles.cover } onClick={ () => this._handleColorPickerClose('text') }/>
                      <ChromePicker 
                        color = { this.state.textColor }
                        onChange={ (color) => this._handleColorPickerChangeComplete(color, "textColor")  }
                      />
                    </div>  
                  }
                </Col>
              </Row>

              <Row className = {cx(styles.row)}>
                  <Col sm = {12}>
                  <div className={cx(styles.summary)}>
                  <textarea rows="2"
                    placeholder={`${ this.localizedDrift.activate.placeholder.welcome_message}:`}
                    onChange={this._handleFieldChange.bind(this, 'welcomeMessage')}
                    value={this.state.welcomeMessage}>
                  </textarea>
                  </div>
                  </Col>
              </Row>

    
              { !this.props.integration && 
                <button className={styles.button} 
                onClick={() => {
                  this._handleSaveChangesClick("activate")
                }}
                disabled={this.props.activating}>
                  {this.props.activating &&
                    `${this.localizedIntegrations.actions.activating}...`
                  }

                  {!this.props.activating &&
                    this.localizedIntegrations.actions.activate
                  }
                </button>
              }
              {this.props.integration && 
                <div className = {styles.alignment}>
                  <button className={styles.button}  
                  onClick={() => {
                    this._handleSaveChangesClick("save_changes")
                  }}
                  disabled={this.props.activating}>
                    {this.props.activating &&
                      `${this.localizedCommons.actions.saving_changes}...`
                    }

                    {!this.props.activating &&
                      this.localizedCommons.actions.save
                    }
                  </button>
                  <button className={cx(styles.button, styles.cancel)} onClick = { this._handleCancelClick } >
                      { this.localizedCommons.actions.cancel }
                  </button>
                </div>
              }  
            </div>
          </Col>
          <Col sm={4} className = {styles.iconAlign}>
            <div className = {styles.background} >
              <div className = { styles.indicator }
                style = { rightAligned}>
                <div className = { styles.foregroundIndicator }
                style = { foregroundColor } >
              </div>
              </div>
            </div> 
          </Col>
          </Row>

          <Col sm={9} className = {styles.description}>
          {this.localizedDrift.customization} <span><a href= {advancedSettings} target="_blank" > {this.localizedDrift.advanced_settings}</a></span>
          </Col>
        </div>
      </Row>
    );
  }
}

export default DriftActivationView;